<section class="py-10 md:py-[72px]" data-aos="fade-up">
  <div class="flex flex-col md:flex-row justify-around gap-10 text-center">
    <div *ngFor="let stat of stats">
      <p class="text-[36px] md:text-[46px] lg:text-[56px] font-bold text-[#0C2551] leading-none mb-2"
         [innerHTML]="stat.statKey | translate | accent">
      </p>
      <p class="text-[16px] font-medium text-[#0C2551] leading-none mt-4 mb-2">
        {{ stat.labelKey | translate }}
      </p>
      <p class="text-[14px] leading-[21px] text-[#0C2551CC]">
        {{ stat.subKey | translate }}
      </p>
    </div>
  </div>
</section>
